import { Installation } from '@nx-customer-apps/api-planning-projects';

export const getSelectedInstallation = (installationId: number | null, allInstallations: Installation[]): Installation => {
    return allInstallations.find(item => item.id === installationId)!;
};
